import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import platformClient from '@/apiClientPlatform'
import { toast } from 'sonner'

export type PendingPackPurchase = {
  id: string
  amountCfa: number
  currency: string
  status: string
  createdAt: string
  owner: { id: string; name: string }
  pack: { code: string; name: string; messages: number }
}

export const usePendingPackPurchasesQuery = (enabled = true) =>
  useQuery({
    queryKey: ['platform-pack-purchases-pending'],
    enabled,
    refetchInterval: 30_000,
    queryFn: async () => {
      const { data } = await platformClient.get<PendingPackPurchase[]>(
        '/platform/billing/message-pack-purchases/pending'
      )
      return data
    },
  })

export const useConfirmPackPurchaseMutation = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await platformClient.post(
        `/platform/billing/message-pack-purchases/${id}/confirm`
      )
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['platform-pack-purchases-pending'] })
      toast.success('Pack confirmé — quota crédité')
    },
    onError: (e: any) => {
      toast.error('Confirmation échouée', {
        description: e?.response?.data?.message ?? 'Erreur inconnue',
      })
    },
  })
}
